// import $ from 'jquery';
import plugin from '../lib';
import RadioSelection from './radio-selection';

const ELEMENT_SELECTOR = '[data-radio-selection]';
const PLUGIN_NAME = 'RadioSelection';

plugin(PLUGIN_NAME, RadioSelection);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__radio-selection/plugin--bundled.js